import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=48a14c98"
import script from "./LanguagePicker.vue?vue&type=script&lang=ts"
export * from "./LanguagePicker.vue?vue&type=script&lang=ts"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=48a14c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports